import script from "./RenameConversationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenameConversationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RenameConversationDialog.vue?vue&type=style&index=0&id=84180f44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84180f44"]])

export default __exports__